import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const urlRegex =
    /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/; // NOSONAR

export const validUrl = (control: FormControl) =>
    !control?.value || urlRegex.test(control.value) ? null : { UrlInvalid: messages.validation.urlInvalid };
